import React from 'react';
import BrokenImageOutlinedIcon from '@mui/icons-material/BrokenImageOutlined';
import { useTranslation } from 'react-i18next';

import scss from './ErrorLoading.module.scss';

function ErrorLoading() {
  const { t } = useTranslation('story');

  return (
    <div className={scss.wrapper} role='status' aria-label={t('errorLoading')}>
      <BrokenImageOutlinedIcon className={scss.icon} />
      <span className={scss.text}>{t('errorLoading')}</span>
    </div>
  );
}

export default ErrorLoading;
